import { render } from "./DropdownAbsolute.vue?vue&type=template&id=f66623d6"
import script from "./DropdownAbsolute.vue?vue&type=script&lang=js"
export * from "./DropdownAbsolute.vue?vue&type=script&lang=js"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__